import React, { useEffect, useState} from 'react';
import Countdown, {CountdownRenderProps} from 'react-countdown';
import {useDispatch} from 'react-redux';

import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/CloseRounded';
import PinField from "react-pin-field";
import {InputAdornment, TextField} from '@mui/material';
import {GoogleLogin} from '@react-oauth/google';
import {WorldModel} from "@/core/tools/world_wiki/worldCountry.model";
import {AppDispatch} from "@/core/redux/store";
import useLocalStorage from "@/core/utils/localStorage";
import {ENGLISH_APP, LOGIN_STATE_KEY} from "@/core/services/CONSTANTS";
import {useTranslations} from "use-intl";
import {showErrorMessage, showSuccessMessage} from "@/core/reducer/messageReducer";
import {Row} from "@/core/general/row.component";
import {Column} from "@/core/general/column.component";
import {Loader} from "@/core/general/ui/loader.component";
import {toPersianNumber} from "@/core/utils/number.utils";
import {saveLoginParams} from "@/core/services/localStorage.service";
import {loginState} from "@/core/reducer/loginReducer";
import {LOGIN_STATE} from "@/core/reducer/CONSTANTS";
import {LoginService} from "@/core/tools/profile/login/login.service";
import Twemoji from "react-twemoji";
import {getFlagEmoji} from "@/core/tools/world_wiki/worldWiki.component";
import {GoogleReCaptchaProvider, useGoogleReCaptcha} from 'react-google-recaptcha-v3';

interface LoginProps {
    countryClick: () => void
    loginSuccess: () => void
    worldItem?: WorldModel | null
}

export default function LoginEnterNumber(props:LoginProps){
    const t = useTranslations();

    const [phoneNumber, setPhoneNumber] = useState('');
    const [isLoginStep, setLoginStep] = useState(true);
    const [isLoadingCapt, setLoadingCapt] = useState(true);
    const [isLoading, setLoading] = useState(false);
    const [isCountDownComplete, setCountDownComplete] = useState(false);
    const dispatch = useDispatch<AppDispatch>();
    let enteredCode: string = '';
    const loginService = new LoginService();
    const [chooseWorldItem, setChooseWorldItem] = useState<WorldModel | null>(null);
    const [isIran, setIran] = useState(true);
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [msg, setMsg] = useState<string | null>(null);

    const [isLogin, setLogin] = useLocalStorage<boolean>(LOGIN_STATE_KEY, false);
    useEffect(() => {
        setLoadingCapt(!executeRecaptcha)
    },[executeRecaptcha])
    useEffect(() => {
        if (props?.worldItem) {
            setIran(props?.worldItem?.Code === "IR");
        } else {
            setIran(true);
        }
        setChooseWorldItem(props.worldItem ?? null);
    }, [props.worldItem])


    const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
        const number = event.currentTarget.value.slice(0, 12).replace(RegExp('^09'), '9');
        setPhoneNumber(number);
    };

    function onEnterPhoneNumberClick() {
        const regex = new RegExp(isIran ? '9[0-9]{9}$' : '')
        if (!executeRecaptcha) return setMsg("ایراد در اهراز هویت. صفحه را بروز کنید");
        const token = executeRecaptcha(''); // “action” label
        token.then((result) => {
            setLoadingCapt(false)
            if (regex.test(phoneNumber)) {
                setLoading(true);
                if (isIran) {
                    loginService.getVerificationCode(phoneNumber,result).subscribe(
                        () => {
                            setLoading(false);
                            setLoginStep(false);
                        },
                        (error) => {
                            setLoading(false);
                        },
                        null
                    );
                } else {
                    loginService.getVerificationCodeForeign(chooseWorldItem?.Tel + phoneNumber, chooseWorldItem?.Code.toString() ?? "98",result).subscribe(
                        () => {
                            setLoading(false);
                            setLoginStep(false);
                        },
                        () => {
                            setLoading(false);
                        },
                        null
                    );
                }
            } else {
                dispatch(showErrorMessage(t('error.numberNotValid')));
            }
        }).catch(() => {
            setMsg("ایراد در اهراز هویت. صفحه را بروز کنید")
            // setLoadingCapt(false)
        })
    }

    function onCodeEntered() {
        if (isCountDownComplete) {
            setLoading(true);
            if (isIran) {
                loginService.getVerificationCode(phoneNumber,"").subscribe(
                    () => {
                        setLoading(false);
                        setLoginStep(false);
                    },
                    (error) => {
                        setLoading(false);
                        dispatch(showErrorMessage(error?.message ?? t('profile.generalError')));
                    }
                );
            } else {
                loginService.getVerificationCodeForeign(chooseWorldItem?.Tel + phoneNumber, chooseWorldItem?.Code.toString() ?? "IR","").subscribe(
                    () => {
                        setLoading(false);
                        setLoginStep(false);
                    },
                    () => {
                        setLoading(false);
                    }
                );
            }
            setCountDownComplete(false);
        } else {
            if (isIran) {
                loginService.getVerifyCode(enteredCode, phoneNumber).subscribe(
                    (data) => {
                        if (data && data.data?.access) {
                            setLogin(true);
                            dispatch(showSuccessMessage(t('profile.loginCorrectly')));
                            saveLoginParams(data.data.access, data.data.refresh, '0' + phoneNumber, data.data.user_id.toString());
                            dispatch(loginState({
                                openLoginPage: false,
                                state: LOGIN_STATE
                            }));
                            props.loginSuccess()
                        }
                    },
                    (error) => {
                        setLoading(false);
                        dispatch(showErrorMessage(error?.message ?? t('profile.enterCodeNotCorrect')));
                    }
                );
            } else {
                loginService.getVerifyCodeForeign(enteredCode, chooseWorldItem?.Tel + phoneNumber, chooseWorldItem?.Code.toString() ?? "IR").subscribe(
                    (data) => {
                        if (data && data.data?.access) {
                            setLogin(true);
                            dispatch(showSuccessMessage(t('profile.loginCorrectly')));
                            saveLoginParams(data.data.access, data.data.refresh, '0' + phoneNumber, data.data.user_id.toString());
                            dispatch(loginState({
                                openLoginPage: false,
                                state: LOGIN_STATE
                            }));
                            props.loginSuccess()
                        }
                    },
                    () => {
                        setLoading(false);
                    }
                );
            }
        }
    }

    function resetNumberClick() {
        return () => {
            setPhoneNumber('');
            enteredCode = '';
            setLoginStep(true);
        };
    }

    const renderer = (props: CountdownRenderProps | any) => {
        if (props.completed) {
            setCountDownComplete(true);
            return <div/>;
        } else {
            return (
                <div className="flex flex-row mt-4">
                    <div className="mText fs-7 text-bold">
                        {t('profile.second', {second: toPersianNumber(props.seconds.toString())})}
                    </div>
                    <div className="fs-7 mTextLighter mx-1">{t('profile.untilResendCode')}</div>
                </div>
            );
        }
    };

    function onLoginNumberKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
        if (event.keyCode == 13) {
            event.preventDefault();
            onEnterPhoneNumberClick();
        }
    }

    function closeLogin() {
        dispatch(loginState({
            openLoginPage: false,
            state: LOGIN_STATE}));
    }

    function countryClick() {
        props.countryClick()
    }

    return (
        <Column>
            <Column className="p-4 justify-center relative">
                <Column className="relative px-4">
                    <CloseIcon className="closeIcon" fontSize={'large'} onClick={() => closeLogin()}/>
                    <div className="text-bold text-base mx-8 mt-4 font">
                        {isLoginStep ? t('profile.loginSignUp') : t('profile.authentication')}
                    </div>
                </Column>
                <Column className="totalCenter mt-6">
                    {isLoginStep ? (
                            <Column className="totalCenter">
                            <TextField
                                value={""}
                                InputProps={{
                                    style: {
                                        cursor: "pointer",
                                        padding: '0.2rem',
                                    },
                                    startAdornment: (
                                        <InputAdornment onClick={() => countryClick()} className={"!w-full"}
                                                        position={'start'}>
                                            <Row className={"items-center px-4"}>
                                                <Twemoji options={{ className: 'twemoji' }}>
                                                    <div className={"!w-8 !h-8 overflow-hidden"}>
                                                        {getFlagEmoji(chooseWorldItem?.Code??"IR")}
                                                    </div>
                                                </Twemoji>
                                                <div
                                                    className={"px-2 text-black"}>{chooseWorldItem?.Name ?? "ایران"}</div>
                                            </Row>
                                        </InputAdornment>
                                    ),
                                }}
                                disabled={true}
                                autoComplete="off"
                                className="searchBox mb-3 mt-1 pointer"
                                label={t('profile.country')}
                                variant={'outlined'}
                            />
                            <TextField
                                autoFocus
                                value={phoneNumber}
                                style={{direction: 'ltr', marginTop: "1rem"}}
                                onKeyDown={(event) => onLoginNumberKeyDown(event)}
                                InputProps={{
                                    inputMode: 'numeric',
                                    style: {
                                        padding: '0.2rem'
                                    },
                                    startAdornment: (
                                        <InputAdornment position={'start'}>
                                            <div className={'mTextLighter px-1'} style={{direction: 'ltr'}}>
                                                +{chooseWorldItem?.Tel ?? "98"} |
                                            </div>
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position={'start'}>
                                            <HighlightOffIcon
                                                style={{display: phoneNumber ? 'block' : 'none'}}
                                                className={`mTextLightBlue mb-1`}
                                                onClick={() => setPhoneNumber('')}
                                            />
                                        </InputAdornment>
                                    )
                                }}
                                focused
                                autoComplete="off"
                                type={'number'}
                                onChange={onChangeText}
                                className="searchBox mb-3 mt-1"
                                label={t('profile.phoneNumber')}
                                variant={'outlined'}
                            />
                            <div className="mTextLightBlue mx-2 text-center mt-2 p-1 text-xs">
                                <span>{t('profile.withEnter')}</span>
                                <span
                                    className="mTextBlue pointer"
                                    onClick={() =>
                                        typeof window !== 'undefined'
                                            ? window.open((`${process.env.NEXT_PUBLIC_NODE_ENV}`.trim() == ENGLISH_APP) ? "https://tlbxapp.com/terms" : "https://tlbx.ir/terms", '_self')
                                            : null
                                    }
                                >{t('profile.termOfService')}</span>
                                <span>{t('profile.and')}</span>
                                <span
                                    className="mTextBlue pointer"
                                    onClick={() =>
                                        typeof window !== 'undefined'
                                            ? window.open((`${process.env.NEXT_PUBLIC_NODE_ENV}`.trim() == ENGLISH_APP) ? "https://tlbxapp.com/privacy" : "https://tlbx.ir/privacy", '_self')
                                            : null
                                    }
                                >{t('profile.privacyPolicy')}</span>
                                <span>{t('profile.iAccept')}</span>
                            </div>
                                {msg?<div className={"text-lg mTextRed"}>{msg}</div>:null}
                            <Column className="relative totalCenter ">
                                <div
                                    style={{opacity: isLoading ? 0.5 : 1}}
                                    className={`enterButton mt-2 text-center text-bold text-base pointer w-90 ${
                                        isLoading ? 'mTextBlue' : 'text-white'
                                    }`}
                                    onClick={() => onEnterPhoneNumberClick()}
                                >
                                    {t('profile.receiveEnteredCode')}
                                </div>
                                {isLoading ? (
                                    <div className="mainLoaderLogin">
                                        <Loader isFullScreen={false}/>
                                    </div>
                                ) : null}
                                {isLoadingCapt ? (
                                    <div className="mainLoaderLogin">
                                        <Loader isFullScreen={false}/>
                                    </div>
                                ) : null}
                            </Column>
                        </Column>
                    ) : (
                        <Column className="totalCenter">
                            <div className="mText px-4 fs-7 p-1 text-start w-full">
                                {t('profile.authenticationMessage', {phone: toPersianNumber('0' + phoneNumber)})}
                            </div>
                            <div className="px-4 pt-2 text-base mTextGold text-start w-full"
                                 onClick={resetNumberClick()}>
                                {t('profile.editPhoneNumber')}
                            </div>
                            <Row className={"relative pt-4 pb-2"} dir={"ltr"}>
                                <PinField
                                    length={4}
                                    onChange={(value: string) => {
                                        enteredCode = value;
                                    }}
                                    className={"pinInputItem"}
                                    type="numeric"
                                    dir="ltr"
                                    inputMode="numeric"
                                    onComplete={(value: string) => {
                                        enteredCode = value;
                                        onCodeEntered();
                                    }}
                                    autoFocus={true}
                                />
                            </Row>
                            {isCountDownComplete ? null : (
                                <Countdown date={Date.now() + 60000} intervalDelay={0} renderer={renderer}/>
                            )}
                            {isIran ? null :
                                <Column className={"mt-4 totalCenter"}>
                                    <GoogleLogin useOneTap={true} text={"signin_with"} locale={"fa"}
                                                 onSuccess={credentialResponse => {
                                                     loginService.loginWithGoogle(credentialResponse.credential ?? "").subscribe((data) => {
                                                         if (data && data.data?.access) {
                                                             dispatch(showSuccessMessage(t('profile.loginCorrectly')));
                                                             saveLoginParams(data.data.access, data.data.refresh, `${data.data.first_name} ${data.data.last_name}`, data.data.user_id.toString());
                                                             dispatch(loginState({
                                                                 state: LOGIN_STATE,
                                                                 openLoginPage: false
                                                             }));
                                                             setLogin(true);
                                                         }
                                                     })
                                                 }}
                                                 onError={() => {
                                                     console.log('Login Failed');
                                                 }}
                                    />
                                </Column>}
                            <div
                                className="enterButton mt-4 text-center text-bold text-base pointer w-90"
                                onClick={() => onCodeEntered()}
                            >
                                {isCountDownComplete ? t('profile.resendCode') : t('profile.enter')}
                            </div>
                        </Column>
                    )}
                </Column>
            </Column>
        </Column>
    );
};
